module.exports = __webpack_public_path__ + "static/video_4-7e05cfd87d26b28f56ae04a70370284a.webm";